import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

export type SPBenefitTokenLocs =
	| 'SPBenefitTokenPageSectionTitle'
	| 'SPBenefitTokenPageTitle'
	| 'SPBenefitTokenPageHeading';

export const spBenefitTokenLocs: LocDefs<SPBenefitTokenLocs> = {
	SPBenefitTokenPageSectionTitle: {
		defaultValue: 'Individual Tokens',
		description: 'Title for the benefit tokens page',
		displayPath: 'Catalogs|Benefits|Tokens|AvailableTokens',
		displayType: 'Title',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Title.IndividualTokensPageSection',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenPageTitle: {
		defaultValue: 'Benefit Tokens',
		description: 'Title for the benefit tokens page',
		displayPath: 'Catalogs|Benefits|Tokens|Page Title',
		displayType: 'Title',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Title.PageTitle',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenPageHeading: {
		defaultValue: 'Benefits Catalog',
		description: 'Heading for the benefit tokens page',
		displayPath: 'Catalogs|Benefits|Tokens|Page Heading',
		displayType: 'Title',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.Benefits.Title.PageTitle',
		portal: 'SP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<SPBenefitTokenLocs>(spBenefitTokenLocs);
export type SpBenefitTokenLocKeys = LocMap<SPBenefitTokenLocs>;
